export default __webpack_public_path__ + "static/media/5f8c90a6399a217f.588207e6876af39bb51f0968e24696fa.svg";